import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ManageImageService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  addImage(body: BaseResponse) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });    
    const link = this.apiUrl + ApiUrls.insertImage;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }

  updateImage(body: BaseResponse) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });    
    const link = this.apiUrl + ApiUrls.updateImage;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }

  getImageById(id: string|number){
    const link = this.apiUrl + ApiUrls.getImageById+"/"+id;
    return this.http.get<BaseResponse>(link);
  }

  getImageList(body:any){
    const link = this.apiUrl + ApiUrls.getImageList;
    return this.http.post<BaseResponse>(link, body);
  }

  deleteImage(body: any){
    const link = this.apiUrl + ApiUrls.deleteImage;
    return this.http.post<BaseResponse>(link, body);
  }

  getImage(param:any){
    const link = this.apiUrl+ApiUrls.getImage;
    return this.http.post<BaseResponse>(link,null,{params:param});
  }
}
